/*
 * @Author: libo 
 * @Date: 2020-11-13 16:50:33 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-04-06 19:50:51
 */

<!--开户页面-->
<template>
    <a-spin :spinning="confirmLoading">
        <j-form-container :disabled="formDisabled">
        <a-form :form="form" slot="detail" :colon="false">
            <div class="form-contain">
                <a-row>
                    <a-col :span="24" class="descriptions">
                        <a-descriptions title="" :column="{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }" size="small">
                            <a-descriptions-item :label="$t('区域名称')">
                                {{model.userAreaName}}
                            </a-descriptions-item>
                            <a-descriptions-item :label="$t('用户地址')">
                                {{model.userAddr}}
                            </a-descriptions-item>
                            <a-descriptions-item :label="$t('表安装地址')">
                                {{model.userMeterAddr}}
                            </a-descriptions-item>
                            <a-descriptions-item :label="$t('安装经纬度')">
                                {{model.userMeterLng,model.userMeterLat}}
                            </a-descriptions-item>
                            <a-descriptions-item :label="$t('表编号')">
                                {{model.meterId}}
                            </a-descriptions-item>
                        </a-descriptions>
                    </a-col>
                </a-row>
                <a-row :gutter="16">
                    <a-divider orientation="left">
                        {{ $t('用户信息') }}
                    </a-divider>
                    <a-col :span="8">
                        <a-form-item :label="$t('用户编号')">
                        <a-input v-decorator="['userId',validatorRules.userId]" :placeholder="$t('请输入用户编号')"></a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-item :label="$t('用户姓名')">
                        <a-input v-decorator="['userName',validatorRules.userName]" :placeholder="$t('请输入用户姓名')"></a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-item :label="$t('手机号码')">
                        <a-input v-decorator="['userPhone',validatorRules.userPhone]" :placeholder="$t('请输入用户手机号')"></a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-item :label="$t('身份证号')">
                        <a-input v-decorator="['userIdNumber',validatorRules.userIdNumber]" :placeholder="$t('请输入身份证号')">
                        </a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-item :label="$t('户型ID')">
                        <a-select v-decorator="['userHouseholdCode',validatorRules.userHouseholdCode]"
                            :placeholder="$t('请选择用户户型id')"
                            :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}">
                            <a-select-option v-for="data in userHouseholdCodeList" :key="data.id" :value="data.id">
                            {{ data.htName }}
                            </a-select-option>
                        </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-item :label="$t('类型编码')">
                        <a-select v-decorator="['userTypeCode',validatorRules.userTypeCode]" :placeholder="$t('请选择用户类型编码')"
                            :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}">
                            <a-select-option v-for="data in userTypeList" :key="data.id" :value="data.id">
                            {{data.utName}}
                            </a-select-option>
                        </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :span="24">
                        <a-form-item :label="$t('备注')">
                        <a-textarea v-decorator="['remark']" rows="3" :placeholder="$t('请输入备注')" style="width:100%" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="24">
                        <a-collapse v-model="defaultkey">
                        <a-collapse-panel key="1" :header="$t('用户选填信息')" :forceRender="true">
                            <a-row :gutter="16">
                            <a-col :span="8">
                                <a-form-item :label="$t('营收编号')">
                                <a-input v-decorator="['userPayId']" :placeholder="$t('请输入用户营收编号')"></a-input>
                                </a-form-item>
                            </a-col>
                            <a-col :span="8">
                                <a-form-item :label="$t('类型')">
                                <a-select v-decorator="['userIdType']" :placeholder="$t('请选择类型')"
                                    :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}">
                                    <a-select-option :value="1">
                                    {{ $t('自然人') }}
                                    </a-select-option>
                                    <a-select-option :value="0">
                                    {{ $t('企业') }}
                                    </a-select-option>
                                </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="8">
                                <a-form-item :label="$t('小区名或村庄名')">
                                <a-input v-decorator="['userCommName']" :placeholder="$t('请输入用户所在小区名或村庄名')"></a-input>
                                </a-form-item>
                            </a-col>
                            <a-col :span="8">
                                <a-form-item :label="$t('是否允许缴费')">
                                <j-dict-select-tag v-decorator="['userPayState', validatorRules.userPayState]"
                                    :triggerChange="true" :placeholder="$t('请选择是否允许缴费')" dictCode="yn" style="width:100%" />
                                </a-form-item>
                            </a-col>
                            <a-col :span="8">
                                <a-form-item :label="$t('优惠信息')">
                                    <j-dict-select-tag v-decorator="['userFreeinfo', validatorRules.userFreeinfo]"
                                    :triggerChange="true" :placeholder="$t('请选择优惠信息')" dictCode="userFreeinfo" style="width:100%" />
                                </a-form-item>
                            </a-col>
                            </a-row>
                        </a-collapse-panel>
                        </a-collapse>
                    </a-col>
                </a-row>
            </div>
        </a-form>
        </j-form-container>
    </a-spin>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue,listSize } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import { duplicateCheck,queryAreaTreeList } from '@/api/api'
  export default {
        name: 'MeterOpenAccountForm',
        components: {
            JFormContainer,
        },
        data () {
        return {
            seen:false,
            treeData:[],
            condition:false,
            activeKey:[1,2,3],
            defaultkey:'',
            form: this.$form.createForm(this),
            model: {},
            confirmLoading: false,
            userHouseholdCodeList:[], // 用户户型
            userTypeList:[], //  类型编码
            userPriceCode:[], // 价格编码
            url: {
            add: "/jeecg-charge/meter/meterUserinfo/add",
            edit: "/jeecg-charge/meter/meterUserinfo/edit",
            queryById: "/jeecg-charge/meter/meterUserinfo/queryById",
            userHouseholdCodeList: "/jeecg-charge/meter/meterHousehold/list",
            userTypeList:"/jeecg-charge/meter/meterUserType/list",
            userPriceCode:"/jeecg-charge/meter/meterPriceinfo/list",
            },
        }
    },
    computed: {
      validatorRules () {
        return {
          userId:{  // 用户编号
            rules:[
              {required:true, message:this.$t('请输入用户编号！')},
            ]
          }
        }
      },
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      }
    },
    created () {
    },
    methods: {
        add () {
            this.edit({});
        },
        edit (record) {
            this.form.resetFields();
            this.model = Object.assign({}, record);
            this.visible = true;
            this.$nextTick(() => {
            this.form.setFieldsValue(pick(this.model,'meterId','userId','userName','userHouseholdCode','userTypeCode','userPhone','userPriceCode','userAddr','userMeterAddr','userMeterLng','userMeterLat','userAddrId','userPayId','userIdNumber','userIdType','userAreaId','userAreaName','userCommName','userState','userMeterStartNum','userMeterOpenNum','userPayState','userFreeinfo','userValveOpenorclose','createTime','createBy','remark'))
            })
            this.queryUserHouseholdCodeList()
            this.queryUserTypeList()
            this.queryUserPriceCode()
        },
        submitForm () {
            const that = this;
            // 触发表单验证
            this.form.validateFields((err, values) => {
            if (!err) {
                that.confirmLoading = true;
                let httpurl = '';
                let method = '';
                if(!this.model.id){
                httpurl+=this.url.add;
                method = 'post';
                }else{
                httpurl+=this.url.edit;
                method = 'put';
                }
                let formData = Object.assign(this.model, values);
                console.log("表单提交数据",formData)
                httpAction(httpurl,formData,method).then((res)=>{
                if(res.success){
                    that.$message.success(res.message);
                    setTimeout(() => {
                        that.$emit('ok');
                    },400)
                }else{
                    that.$message.warning(res.message);
                }
                }).finally(() => {
                that.confirmLoading = false;
                })
            }
            })
        },
        queryUserHouseholdCodeList() {
            let params = {}
            params.pageNo = 1;
            params.pageSize = listSize;
            getAction(this.url.userHouseholdCodeList, params).then((res) => {
            if(res.success){
            this.userHouseholdCodeList = res.result.records;
            }
            })
        },
        queryUserTypeList() {
            let params = {}
            params.pageNo = 1;
            params.pageSize = listSize;
            getAction(this.url.userTypeList, params).then((res) => {
            if(res.success){
            this.userTypeList = res.result.records;
            }
            })
        },
        queryUserPriceCode() {
            let params = {}
            params.pageNo = 1;
            params.pageSize = listSize;
            getAction(this.url.userPriceCode, params).then((res) => {
            if(res.success){
                this.userPriceCode = res.result.records;
                console.log(this.userPriceCode);
            }
            }) 
        },
        onChange(value) {
        // console.log(value);
        },
        // 查询表编号名称是否重复
        validatePlanName(rule, value, callback){
            var params ={
            tableName:'meterinfo',
            fieldName:'meter_id',
            fieldVal:value,
            dataId:this.model.id
            };
            console.log(params);
            duplicateCheck(params).then((res) => {
            console.log(res);
            if (res.success) {
                callback(this.$t("请在表具信息页面中添加"))
            } else {
                callback()
            }
            })
        },
        shut(){    //关闭按钮
            this.defaultkey = '';
            this.form.resetFields();
        }
    }
}
</script>
<style scoped>
.ant-form-item >>> .ant-form-item-label{
    line-height: 20px;
}
.ant-form-item >>> .ant-select{
    width: 100%;
}
.form-contain{
    height: 60vh;
    overflow-y: scroll;
    overflow-x: hidden;
}
.descriptions /deep/ .ant-descriptions .ant-descriptions-item-label{
    background-color: unset;
    color: rgba(24,144,255,0.85);
}
</style>